import { render, staticRenderFns } from "./base-about.vue?vue&type=template&id=16bb8bec&scoped=true&"
import script from "./base-about.vue?vue&type=script&lang=js&"
export * from "./base-about.vue?vue&type=script&lang=js&"
import style0 from "./base-about.vue?vue&type=style&index=0&id=16bb8bec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bb8bec",
  null
  
)

export default component.exports